var _circle, _circle2, _circle3, _circle4, _ellipse, _ellipse2, _ellipse3, _ellipse4, _ellipse5, _ellipse6, _path, _circle5, _circle6, _circle7, _circle8, _path2, _rect, _circle9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBongbong(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "15 -6 170 170",
    width: 512,
    height: 512,
    role: "img",
    "aria-label": "Bongbong the bear",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Bongbong") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 48,
    cy: 46,
    r: 22,
    fill: "#F1DDBF",
    stroke: "#4A3426",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 48,
    cy: 46,
    r: 11,
    fill: "#F5C6C0"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 152,
    cy: 46,
    r: 22,
    fill: "#F1DDBF",
    stroke: "#4A3426",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 152,
    cy: 46,
    r: 11,
    fill: "#F5C6C0"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 100,
    cy: 92,
    rx: 68,
    ry: 60,
    fill: "#F1DDBF",
    stroke: "#4A3426",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 58,
    cy: 114,
    rx: 11,
    ry: 6.5,
    fill: "#F7A8B8",
    opacity: 0.7
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 142,
    cy: 114,
    rx: 11,
    ry: 6.5,
    fill: "#F7A8B8",
    opacity: 0.7
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 100,
    cy: 114,
    rx: 27,
    ry: 19,
    fill: "#FFF6E8"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 100,
    cy: 106,
    rx: 9,
    ry: 6.5,
    fill: "#4A3426"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 97,
    cy: 104,
    rx: 3,
    ry: 1.8,
    fill: "#fff",
    opacity: 0.7
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M90 116 Q95 123 100 117 Q105 123 110 116",
    fill: "none",
    stroke: "#4A3426",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 72,
    cy: 92,
    r: 6.5,
    fill: "#4A3426"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 74,
    cy: 89.5,
    r: 2.2,
    fill: "#fff"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 128,
    cy: 92,
    r: 6.5,
    fill: "#4A3426"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 130,
    cy: 89.5,
    r: 2.2,
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M62 44 Q100 4 138 44 Z",
    fill: "#6FA8DC",
    stroke: "#4A3426",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 52,
    y: 40,
    width: 96,
    height: 10,
    rx: 5,
    fill: "#4F8CC9",
    stroke: "#4A3426",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 27,
    r: 6,
    fill: "#FFD34E",
    stroke: "#4A3426",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBongbong);
export default __webpack_public_path__ + "static/media/bongbong.44893dc8e07e2960632845c754aaf29b.svg";
export { ForwardRef as ReactComponent };